export class LoadStages {
  static readonly type = '[Stages] Load stages';
}
